import { Stat } from '@/components/ui/Stat';
import { useBillingOverview } from '@/hooks/useAdminBilling';
import { formatCurrency } from '@/utils/formatters';
import { Euro } from 'lucide-react';

export function MRRCard() {
  const { data } = useBillingOverview();
  // Billing overview API returns { mrr, arr, churn, ... } directly
  return (
    <Stat
      label="MRR"
      value={data?.mrr != null ? formatCurrency(data.mrr) : '--'}
      trend={data?.mrrGrowth}
      icon={<Euro className="h-5 w-5" />}
    />
  );
}
